import type { IDashboardRepository } from "@/application/ports/repositories";
import type {
	DashboardMetrics,
	DashboardMetricsParams,
	InvestmentAggregationMetrics,
	InvestmentAggregationMetricsParams,
} from "@/domain/dashboard";
import { apiClient } from "../client";

export class DashboardRepository implements IDashboardRepository {
	async getMetrics(
		params: DashboardMetricsParams = {},
	): Promise<DashboardMetrics> {
		const searchParams = new URLSearchParams();
		if (params.beneficiary_uuid)
			searchParams.append("beneficiary_uuid", params.beneficiary_uuid);
		if (params.fiscal_year)
			searchParams.append("fiscal_year", params.fiscal_year.toString());

		const queryString = searchParams.toString();
		const url = queryString
			? `/dashboard/metrics?${queryString}`
			: "/dashboard/metrics";

		const response = await apiClient.get<DashboardMetrics>(url);
		return response.data;
	}
	async getInvestmentMetrics(
		params: InvestmentAggregationMetricsParams = {},
	): Promise<InvestmentAggregationMetrics> {
		const searchParams = new URLSearchParams();
		if (params.investor_uuid)
			searchParams.append("investor_uuid", params.investor_uuid);
		if (params.beneficiary_uuid)
			searchParams.append("beneficiary_uuid", params.beneficiary_uuid);
		if (params.fiscal_quota_uuid)
			searchParams.append("fiscal_quota_uuid", params.fiscal_quota_uuid);
		if (params.fiscal_year)
			searchParams.append("fiscal_year", params.fiscal_year.toString());
		if (params.states && params.states.length > 0) {
			params.states.forEach((state) => searchParams.append("states", state));
		}
		if (params.group_by) searchParams.append("group_by", params.group_by);
		if (params.investor_type)
			searchParams.append("investor_type", params.investor_type);

		const queryString = searchParams.toString();
		const url = queryString
			? `/dashboard/investments?${queryString}`
			: "/dashboard/investments";

		const response = await apiClient.get<InvestmentAggregationMetrics>(url);
		return response.data;
	}
}
